

  export  function formatDateTime(dateTime) {
    if (!dateTime) return "";

    const formattedDate = new Date(dateTime).toLocaleDateString('en-US', {
      month: 'numeric',
      day: 'numeric',
      year: 'numeric'
    });

    const formattedTime = new Date(dateTime).toLocaleTimeString('en-US', {
      hour: 'numeric',
      minute: 'numeric',
      second: 'numeric'
    });

    return `${formattedDate} ${formattedTime}`;
  }

  export function formatIncubatorTime(inTime, outTime) {
    if (!inTime || !outTime) return "Invalid Time";
  
    const inDate = new Date(inTime);
    const outDate = new Date(outTime);
  
    if (isNaN(inDate) || isNaN(outDate)) return "Invalid Date";
  
    const diffMs = outDate - inDate; // Difference in milliseconds
    if (diffMs < 0) return "Invalid Range"; // If outTime is before inTime
  
    const diffHours = Math.floor(diffMs / (1000 * 60 * 60)); // Convert to hours
    const diffMinutes = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60)); // Remaining minutes
  
    return `${diffHours}h ${diffMinutes}m`;
  }
  